var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8235C2.5 6.88618 6.63213 3.5 12 3.5C17.3679 3.5 21.5 6.88618 21.5 10.8235C21.5 14.7609 17.3679 18.1471 12 18.1471C11.3111 18.1471 10.6409 18.0839 9.99 17.9734C9.64259 17.9144 9.29121 18.0386 9.05708 18.2983C8.03279 19.4345 6.51885 20.5896 4.32238 21.2162C4.32251 21.2156 4.32266 21.215 4.32284 21.2144C4.32359 21.2118 4.32522 21.2075 4.3293 21.2014C5.28576 19.7691 5.79676 18.4009 6.07047 17.344C6.18075 16.9181 5.99005 16.5002 5.66155 16.2728C3.69391 14.9109 2.5 12.9571 2.5 10.8235Z",
    stroke: "#1D1E2C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.6001,
    y1: 9.5,
    x2: 15.6001,
    y2: 9.5,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 12.5,
    x2: 14.5,
    y2: 12.5,
    stroke: "#1D1E2C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.bd13c3de469571dade7112054a1e1649.svg";
export { ForwardRef as ReactComponent };